module.exports = __webpack_public_path__ + "img/telegram-bot.c47eede1.svg";